import {Form} from 'antd';
import {FormInstance} from 'antd/es/form';
import React from 'react';

import {dynamicFieldResolver} from 'components/ais/monitor-services-card/monitor-service-dynamic-fields/lib/utils';
import {EFormMode} from 'components/form';
import {useFormWatcher} from 'components/form/hooks/use-form-watcher';
import {fieldValidationResolver} from 'components/form/utils/field-validation-resolver';
import {EFieldType, IFieldMeta} from 'entities/metadata';
import {IDynamicInputField} from 'shared/types';
import {useAppSelector} from 'store/config/hooks';
import {selectDocumentsSigningMethod} from 'store/slices/documents-uploading-slice';

interface IMonitorServiceDynamicFieldProps {
    form: FormInstance;
    fieldMeta: IDynamicInputField;
    entityName: string;
    disabled?: boolean;
}

export const MonitorServiceDynamicField = ({
    form,
    fieldMeta,
    entityName,
    disabled,
}: IMonitorServiceDynamicFieldProps) => {
    const documentsSigningMethod = useAppSelector(selectDocumentsSigningMethod);

    const {
        isHidden: isHiddenByWatcher,
        isRequired: isRequiredByWatcher,
        isDisabled: isDisabledByWatcher,
    } = useFormWatcher({
        fieldMeta: fieldMeta as IFieldMeta,
        form,
        entityName,
        formMode: EFormMode.CREATE,
    });

    return (
        <Form.Item
            key={fieldMeta?.id || fieldMeta?.key}
            name={fieldMeta?.key}
            label={fieldMeta?.label}
            style={{width: fieldMeta?.width ?? '100%'}}
            hidden={isHiddenByWatcher}
            rules={fieldValidationResolver({
                validationRules: fieldMeta.validationRules,
                fieldMeta: {
                    type: fieldMeta.type ?? EFieldType.STRING,
                    label: fieldMeta.label ?? '',
                    isRequired: !isHiddenByWatcher && (fieldMeta.isRequired || isRequiredByWatcher),
                },
            })}
        >
            {dynamicFieldResolver({
                form,
                documentsSigningMethod,
                entityName,
                type: fieldMeta.type,
                isDisabled: disabled || fieldMeta.isDisabled || isDisabledByWatcher,
                defaultValue: fieldMeta.defaultValue,
                placeholder: fieldMeta.placeholder,
                referenceUrl: fieldMeta.referenceUrl,
                fieldKey: fieldMeta.key,
                useFirstOptionAsDefaultValue: fieldMeta.useFirstOptionAsDefaultValue,
                requestDateFormat: fieldMeta.requestDateFormat,
                dateFormat: fieldMeta.dateFormat,
                buttonTitle: fieldMeta.buttonTitle,
            })}
        </Form.Item>
    )
}